export type AppSection = "demo" | "my" | "other";

export interface AppConfig {
  id: string;
  name: string;
  description: string;
  url: string;
  icon: string; // lucide icon name
  accentColor: string; // tailwind bg color class
  iconBg: string; // tailwind icon bg class
  section: AppSection;
}

export const APP_SECTIONS: { id: AppSection; title: string }[] = [
  { id: "demo", title: "Solutions for Demo" },
  { id: "my", title: "My Applications" },
];

const apps: AppConfig[] = [
  {
    id: "quote-agent",
    name: "Quote Agent",
    description: "Create, manage and track freight quotations with AI-powered automation.",
    url: "https://quote.wendai.ai",
    icon: "FileText",
    accentColor: "from-blue-500 to-cyan-400",
    iconBg: "bg-blue-100",
    section: "my",
  },
  {
    id: "invoice-agent",
    name: "Invoice Agent",
    description: "Generate, send and reconcile invoices seamlessly with smart workflows.",
    url: "https://invoice.wendai.ai",
    icon: "ReceiptText",
    accentColor: "from-violet-500 to-purple-400",
    iconBg: "bg-violet-100",
    section: "my",
  },
  {
    id: "three-way-match",
    name: "P2P Invoice Matching",
    description: "Automate 3-way PO, GR and invoice matching with real-time exception management.",
    url: "https://3way-match.wendai.ai",
    icon: "GitCompareArrows",
    accentColor: "from-emerald-500 to-teal-400",
    iconBg: "bg-emerald-100",
    section: "demo",
  },
  {
    id: "mdg",
    name: "Master Data Governance",
    description: "Validate, cleanse and govern master data across SAP with intelligent duplicate detection.",
    url: "https://mdg.wendai.ai",
    icon: "DatabaseZap",
    accentColor: "from-amber-500 to-orange-400",
    iconBg: "bg-amber-100",
    section: "demo",
  },
];

export default apps;
